import { render } from "./UnlockCourse.vue?vue&type=template&id=1ca0e4d8&scoped=true"
import script from "./UnlockCourse.vue?vue&type=script&lang=js"
export * from "./UnlockCourse.vue?vue&type=script&lang=js"

import "./UnlockCourse.vue?vue&type=style&index=0&id=1ca0e4d8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1ca0e4d8"

export default script